exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".default{background:rgba(206,220,208,.5)}.new-period-data-container{text-align:center}.new-period-data-container>.xs6>.v-picker{width:90%}.new-period-data-container>.xs6>.v-picker>.v-picker__body{width:90%!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c7f20f04","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ReportingPeriods.vue
// module id = 647
// module chunks = 0